var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 21H10.0001L11.0001 14H7.50011C6.92011 14 6.93011 13.68 7.12011 13.34C7.31011 13 7.17011 13.26 7.19011 13.22C8.48011 10.94 10.4201 7.54 13.0001 3H14.0001L13.0001 10H16.5001C16.9901 10 17.0601 10.33 16.9701 10.51L16.9001 10.66C12.9601 17.55 11.0001 21 11.0001 21Z",
    fill: "#FBF8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltWhite);
export default __webpack_public_path__ + "static/media/bolt_white.7cc9ec42f36ed4c151a8118b101db1cf.svg";
export { ForwardRef as ReactComponent };